import { render, staticRenderFns } from "./StockListUnits.vue?vue&type=template&id=cd2532b6"
import script from "./StockListUnits.vue?vue&type=script&lang=js"
export * from "./StockListUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports